export enum FilterParam {
  ApprovedLenderCode = 'approvedLenderCode',
  DefaultStatus = 'defaultStatus',
}
